import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Sedanacabservice() {



  const cardData = {




keyword: "Sedan Cab Service",

headingDescription: "Garud Cab Service provides comfortable and reliable Sedan Cab Service for airport transfers, corporate travel, family journeys, local transportation, outstation trips, sightseeing, railway station transfers, and long-distance travel. Our sedan cars are suitable for individuals, couples, families, and small groups looking for a smooth and private travel experience. Customers can book chauffeur-driven sedans for one-way journeys, round trips, airport pickup and drop, corporate requirements, and customized travel plans. With clean and well-maintained vehicles, experienced drivers, flexible pickup locations, transparent pricing, and 24/7 customer assistance, Garud Cab Service offers convenient sedan transportation from Pune to popular destinations across Maharashtra and nearby states.",

topPlaces: [
  {
    title: "Mumbai",
    description: "Mumbai is a major business and entertainment destination frequently visited from Pune for corporate meetings, airport transfers, shopping, medical appointments, family functions, and sightseeing. A sedan provides a comfortable option for individuals, couples, and small families traveling between the two cities. Garud Cab Service offers private chauffeur-driven sedan journeys with flexible pickup and drop locations."
  },
  {
    title: "Lonavala",
    description: "Lonavala is a popular hill destination near Pune known for waterfalls, forts, lakes, valleys, and scenic mountain surroundings. A sedan is ideal for couples and small families planning a comfortable weekend journey from Pune. Customers can book a private cab for direct travel, return journeys, or customized sightseeing around Lonavala."
  },
  {
    title: "Mahabaleshwar",
    description: "Mahabaleshwar is a scenic hill station famous for viewpoints, strawberry farms, Venna Lake, waterfalls, and beautiful Sahyadri landscapes. Travelers looking for a comfortable private journey can choose a sedan for their trip from Pune. Garud Cab Service provides chauffeur-driven transportation for one-way travel, round trips, and sightseeing plans."
  },
  {
    title: "Nashik",
    description: "Nashik is an important Maharashtra destination known for Trimbakeshwar, Panchavati, temples, vineyards, and cultural attractions. A sedan is suitable for individuals, couples, and small families traveling from Pune for religious visits, business work, or sightseeing. Travelers can customize their journey according to their preferred pickup, stops, and return schedule."
  },
  {
    title: "Shirdi",
    description: "Shirdi is a renowned pilgrimage destination visited by devotees throughout the year for Sai Baba Darshan. A sedan provides a comfortable and private option for couples, small families, and devotees traveling from Pune. Garud Cab Service offers chauffeur-driven cabs for one-way journeys, return trips, and customized religious travel plans."
  },
  {
    title: "Kolhapur",
    description: "Kolhapur is known for the Mahalaxmi Temple, Panhala Fort, Rankala Lake, traditional cuisine, and rich cultural heritage. A sedan is a convenient choice for small families and groups traveling from Pune to Kolhapur. Customers can book a private cab for direct transportation as well as sightseeing around the city and nearby attractions."
  },
  {
    title: "Goa",
    description: "Goa is a popular destination for beach holidays, couples' trips, family vacations, and weekend getaways from Pune. A sedan offers a private and comfortable road-trip option for smaller groups carrying moderate luggage. Garud Cab Service provides chauffeur-driven sedan bookings for one-way and round-trip Goa journeys with flexible travel arrangements."
  },
  {
    title: "Alibaug",
    description: "Alibaug is a popular coastal destination known for beaches, sea forts, coastal scenery, and relaxing weekend experiences. Couples and small families can choose a sedan for convenient travel from Pune with flexible stopping options. Garud Cab Service provides private chauffeur-driven transportation for direct journeys, return trips, and customized Alibaug sightseeing."
  },
  {
    title: "Aurangabad",
    description: "Aurangabad is a major heritage and religious destination featuring Ellora Caves, Bibi Ka Maqbara, Daulatabad Fort, and Grishneshwar Jyotirlinga. A sedan is suitable for smaller families and travelers who want private transportation for the longer journey from Pune. Customers can also customize their itinerary to cover multiple historical and religious attractions."
  },
  {
    title: "Ujjain",
    description: "Ujjain is an important pilgrimage city in Madhya Pradesh and is famous for Mahakaleshwar Jyotirlinga and several spiritual attractions. Travelers from Pune planning a longer religious journey can choose a comfortable sedan with a professional chauffeur. Garud Cab Service provides flexible one-way, round-trip, and multi-day travel options for this extended route."
  }
],




"services": [
{
"name": "Sedan Cab Service in Pune",
"description": "Book Sedan Cab Service in Pune for comfortable and reliable local, airport, corporate, and outstation transportation with professional chauffeurs and well-maintained AC sedans. The service is suitable for individuals, couples, families, business travelers, tourists, and passengers looking for convenient private travel across Pune and nearby destinations."
},
{
"name": "Sedan Taxi Service Pune",
"description": "Choose Sedan Taxi Service Pune for convenient point-to-point transportation with experienced drivers, comfortable seating, clean AC interiors, and flexible pickup arrangements. Sedan taxis are suitable for local travel, airport transfers, office commuting, shopping trips, personal visits, sightseeing, and planned outstation journeys from Pune."
},
{
"name": "Sedan Cab Booking Pune",
"description": "Make Sedan Cab Booking Pune for scheduled private transportation with convenient pickup and drop facilities. Reserve an AC sedan according to your preferred travel date, timing, passenger requirements, and destination for local rides, airport transfers, business travel, family journeys, and outstation trips."
},
{
"name": "Sedan Cab Hire Pune",
"description": "Hire a Sedan Cab in Pune for comfortable chauffeur-driven transportation without the hassle of driving yourself. Enjoy spacious seating, air conditioning, professional driver service, convenient pickup locations, and flexible travel arrangements for office travel, airport transfers, personal trips, sightseeing, and long-distance journeys."
},
{
"name": "Sedan Taxi Booking Pune",
"description": "Reserve Sedan Taxi Booking Pune for dependable private transportation with trained chauffeurs and comfortable AC vehicles. The service provides convenient travel for individuals, couples, families, tourists, corporate passengers, and customers requiring scheduled local, airport, one-way, round-trip, or outstation taxi services."
},
{
"name": "Sedan Outstation Cab Pune",
"description": "Book Sedan Outstation Cab Pune for comfortable long-distance travel to destinations such as Mumbai, Lonavala, Mahabaleshwar, Nashik, Shirdi, Kolhapur, Goa, and other cities. Enjoy private AC transportation, professional chauffeurs, flexible pickup, luggage space, and convenient one-way or round-trip travel options."
},
{
"name": "Sedan Airport Cab Pune",
"description": "Choose Sedan Airport Cab Pune for convenient pickup and drop transportation to and from Pune Airport. Professional chauffeurs provide timely service, luggage assistance, comfortable AC travel, and direct transfers for individuals, families, corporate passengers, tourists, and travelers requiring reliable airport transportation."
},
{
"name": "Sedan One Way Cab Pune",
"description": "Book Sedan One Way Cab Pune for direct point-to-point travel without arranging a return journey. Enjoy a private AC sedan, experienced chauffeur, convenient pickup, comfortable seating, and luggage space for airport drops, intercity transfers, personal travel, business journeys, and outstation destinations."
},
{
"name": "Sedan Round Trip Cab Pune",
"description": "Reserve Sedan Round Trip Cab Pune for convenient return transportation according to your travel schedule. Enjoy a comfortable AC sedan with professional chauffeur service for family trips, business visits, sightseeing, weekend travel, religious journeys, and outstation tours requiring flexible pickup and return arrangements."
},
{
"name": "AC Sedan Cab Pune",
"description": "Choose AC Sedan Cab Pune for a comfortable private journey with air-conditioned interiors, clean seating, professional chauffeurs, and convenient pickup and drop service. AC sedans are suitable for local travel, airport transfers, corporate transportation, family trips, sightseeing, and outstation journeys throughout Pune and nearby destinations."
},
{
"name": "Online Sedan Cab Booking Pune",
"description": "Make Online Sedan Cab Booking Pune for convenient travel planning from your preferred location. Schedule a comfortable AC sedan with chauffeur service according to your travel date, pickup time, destination, passenger count, and journey type for airport transfers, local rides, corporate travel, and outstation transportation."
},
{
"name": "Corporate Sedan Cab Pune",
"description": "Book Corporate Sedan Cab Pune for professional business transportation with comfortable AC vehicles and experienced chauffeurs. The service is suitable for employee travel, client meetings, office transfers, business events, airport pickups, executive transportation, and scheduled corporate journeys across Pune and surrounding areas."
},
{
"name": "Affordable Sedan Cab Pune",
"description": "Choose Affordable Sedan Cab Pune for economical and comfortable chauffeur-driven transportation without compromising on convenience. Well-maintained AC sedans are available for local travel, airport transfers, office commuting, personal visits, sightseeing, family trips, and outstation journeys based on your travel requirements."
},
{
"name": "Luxury Sedan Cab Pune",
"description": "Hire Luxury Sedan Cab Pune for a refined and comfortable private travel experience with premium interiors, air conditioning, professional chauffeurs, and personalized pickup arrangements. Luxury sedans are suitable for executive travel, corporate meetings, special occasions, airport transfers, business guests, and premium outstation journeys."
},
{
"name": "Sedan Tourist Cab Pune",
"description": "Book Sedan Tourist Cab Pune for comfortable sightseeing and private travel around Pune and nearby tourist destinations. Enjoy an experienced chauffeur, AC interiors, convenient pickup, luggage space, and flexible travel schedules for couples, families, tourists, weekend travelers, and visitors exploring local attractions or outstation destinations."
},
{
"name": "Private Sedan Taxi Pune",
"description": "Choose Private Sedan Taxi Pune for exclusive chauffeur-driven transportation without sharing the vehicle with other passengers. Enjoy comfortable AC travel, flexible pickup locations, direct destination transfers, professional drivers, and suitable arrangements for personal trips, airport travel, business journeys, family transportation, and outstation travel."
},
{
"name": "Local Sedan Cab Service Pune",
"description": "Book Local Sedan Cab Service Pune for convenient transportation within Pune city and surrounding areas. Comfortable AC sedans with professional chauffeurs are suitable for office travel, shopping, appointments, railway station transfers, local sightseeing, family visits, daily transportation, and point-to-point journeys across Pune."
},
{
"name": "Sedan Cab Service in Hinjewadi Pune",
"description": "Choose Sedan Cab Service in Hinjewadi Pune for convenient transportation to IT parks, offices, residential areas, hotels, and Pune Airport. Professional chauffeurs and comfortable AC sedans provide reliable travel for employees, corporate visitors, families, business travelers, and passengers requiring local or outstation transportation."
},
{
"name": "Sedan Cab Service in Kharadi Pune",
"description": "Book Sedan Cab Service in Kharadi Pune for comfortable transportation to business parks, offices, residential societies, hotels, Pune Airport, and other destinations. AC sedans with experienced chauffeurs are suitable for corporate travel, airport transfers, personal journeys, local rides, and outstation trips from Kharadi."
},
{
"name": "Sedan Cab Service in Hadapsar Pune",
"description": "Hire Sedan Cab Service in Hadapsar Pune for convenient local and outstation transportation with professional drivers and clean AC vehicles. The service is suitable for office commuting, airport transfers, railway station travel, family trips, business meetings, sightseeing, and private journeys from Hadapsar to various destinations."
},
{
"name": "Sedan Cab Service in Baner Pune",
"description": "Choose Sedan Cab Service in Baner Pune for reliable private transportation with comfortable AC sedans and trained chauffeurs. Enjoy convenient pickup and drop for corporate offices, hotels, residential areas, Pune Airport, local destinations, and outstation locations while traveling with flexible scheduling."
},
{
"name": "Sedan Cab Service in Wakad Pune",
"description": "Book Sedan Cab Service in Wakad Pune for comfortable travel across Wakad, Hinjewadi, Pimpri Chinchwad, Pune Airport, and nearby destinations. Professional chauffeurs provide convenient local, airport, corporate, sightseeing, one-way, round-trip, and outstation transportation in clean and comfortable AC sedans."
},
{
"name": "Sedan Cab Service in Pimpri Chinchwad",
"description": "Reserve Sedan Cab Service in Pimpri Chinchwad for dependable transportation throughout PCMC and to destinations across Maharashtra. Comfortable AC sedans with experienced chauffeurs are suitable for local travel, corporate transportation, airport transfers, family journeys, sightseeing, railway station drops, and outstation trips."
},
{
"name": "Sedan Cab Service in Viman Nagar Pune",
"description": "Choose Sedan Cab Service in Viman Nagar Pune for convenient transportation near Pune Airport, hotels, offices, residential areas, and commercial destinations. Enjoy professional chauffeur service, comfortable AC interiors, timely pickup, and flexible travel options for airport transfers, corporate travel, local rides, and outstation journeys."
},
{
"name": "Sedan Cab Service in Kothrud Pune",
"description": "Book Sedan Cab Service in Kothrud Pune for comfortable and private transportation with trained chauffeurs and well-maintained AC vehicles. The service is suitable for families, professionals, students, senior passengers, tourists, and business travelers requiring local rides, airport transfers, sightseeing, or outstation transportation."
},
{
"name": "Sedan Cab Service in Magarpatta Pune",
"description": "Hire Sedan Cab Service in Magarpatta Pune for reliable transportation to offices, residential areas, hotels, Pune Airport, and other destinations. Comfortable AC sedans with professional chauffeurs are suitable for corporate employees, business visitors, families, airport passengers, and customers planning local or outstation travel."
},
{
"name": "Sedan Cab Service in Wagholi Pune",
"description": "Choose Sedan Cab Service in Wagholi Pune for convenient private transportation with experienced chauffeurs and comfortable air-conditioned vehicles. The service is suitable for airport transfers, office travel, residential pickups, family journeys, local sightseeing, business trips, and outstation travel from Wagholi to Pune and other destinations."
}
],
"tableData": [
["Sedan Cab Service in Pune", "Sedan Taxi Service Pune"],
["Sedan Cab Booking Pune", "Sedan Cab Hire Pune"],
["Sedan Taxi Booking Pune", "Sedan Outstation Cab Pune"],
["Sedan Airport Cab Pune", "Sedan One Way Cab Pune"],
["Sedan Round Trip Cab Pune", "AC Sedan Cab Pune"],
["Online Sedan Cab Booking Pune", "Corporate Sedan Cab Pune"],
["Affordable Sedan Cab Pune", "Luxury Sedan Cab Pune"],
["Sedan Tourist Cab Pune", "Private Sedan Taxi Pune"],
["Local Sedan Cab Service Pune", "Sedan Cab Service in Hinjewadi Pune"],
["Sedan Cab Service in Kharadi Pune", "Sedan Cab Service in Hadapsar Pune"],
["Sedan Cab Service in Baner Pune", "Sedan Cab Service in Wakad Pune"],
["Sedan Cab Service in Pimpri Chinchwad", "Sedan Cab Service in Viman Nagar Pune"],
["Sedan Cab Service in Kothrud Pune", "Sedan Cab Service in Magarpatta Pune"],
["Sedan Cab Service in Wagholi Pune", ""]
],



whychoose: [
  {
    WhyChooseheading: "Sedan Cab Service for Comfortable Everyday Travel",
    WhyChoosedescription: "Garud Cab Service offers dependable sedan cab services for local Pune travel, airport transfers, business trips, family transportation, railway station pickups, and outstation journeys."
  },
  {
    WhyChooseheading: "Comfortable Cars for Individuals & Families",
    WhyChoosedescription: "Sedan cabs provide a practical combination of comfortable seating, smooth travel, and useful luggage space, making them suitable for individuals, couples, families, and small groups."
  },
  {
    WhyChooseheading: "Convenient Pune Airport Transfers",
    WhyChoosedescription: "Book a sedan for airport pickup or drop when you need a comfortable vehicle for travelling between Pune Airport, your home, hotel, office, or another preferred location."
  },
  {
    WhyChooseheading: "Ideal for Corporate Transportation",
    WhyChoosedescription: "Sedan cab services are suitable for office visits, client meetings, business appointments, conferences, executive transfers, and regular corporate transportation requirements."
  },
  {
    WhyChooseheading: "Local & Outstation Cab Availability",
    WhyChoosedescription: "Use a sedan for local city travel or plan an outstation journey from Pune to nearby cities, tourist destinations, religious places, and other intercity locations."
  },
  {
    WhyChooseheading: "Professional Chauffeur-Driven Travel",
    WhyChoosedescription: "Garud Cab Service can arrange sedan travel with professional drivers, allowing passengers to relax while the driver handles the route and road journey."
  },
  {
    WhyChooseheading: "Useful for One-Way & Round Trips",
    WhyChoosedescription: "Choose one-way transportation when you only need a drop, or book a round trip for return travel, sightseeing, family visits, business appointments, or other planned journeys."
  },
  {
    WhyChooseheading: "Simple Booking with Garud Cab Service",
    WhyChoosedescription: "Share your pickup location, destination, travel date, passenger details, and one-way or return requirement to arrange a suitable sedan cab according to your travel needs."
  }
]


};


const faqData = [
  {
    question: "Does Garud Cab Service provide Sedan Cab Service?",
    answer: "Yes, Garud Cab Service provides sedan cab services for local travel, airport transfers, corporate transportation, family trips, railway station transfers, and outstation journeys."
  },
  {
    question: "Can I book a sedan cab for Pune Airport?",
    answer: "Yes, sedan cabs can be arranged for Pune Airport pickup and drop services according to your flight schedule and preferred pickup time."
  },
  {
    question: "Is sedan cab service available for outstation travel?",
    answer: "Yes, sedan cabs can be booked for suitable outstation destinations from Pune based on your travel requirements and vehicle availability."
  },
  {
    question: "Can I book a one-way sedan cab?",
    answer: "Yes, one-way sedan cab arrangements are available for passengers who need direct transportation to their selected destination."
  },
  {
    question: "Can I book a round-trip sedan?",
    answer: "Yes, round-trip sedan cab services can be arranged for business travel, family visits, sightseeing, religious trips, and other return journeys."
  },
  {
    question: "Is a sedan suitable for family travel?",
    answer: "Yes, sedan cabs are suitable for individuals, couples, and small families who need comfortable seating and convenient luggage space."
  },
  {
    question: "Can corporate customers use sedan cabs?",
    answer: "Yes, corporate customers can use sedan cab services for client meetings, office travel, business appointments, executive transfers, and corporate events."
  },
  {
    question: "Is the sedan cab provided with a driver?",
    answer: "Yes, chauffeur-driven sedan service can be arranged for customers who prefer convenient transportation with a professional driver."
  },
  {
    question: "Can I book a sedan for local sightseeing?",
    answer: "Yes, sedan cabs can be arranged for local sightseeing, shopping, family outings, hotel transfers, and other city travel requirements."
  },
  {
    question: "How can I book a Sedan Cab Service?",
    answer: "Share your pickup location, destination, travel date, passenger count, preferred vehicle, and trip type with Garud Cab Service to arrange your sedan cab."
  }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Aditya Deshpande",
    feedback: "I booked a sedan for an airport transfer in Pune and found the arrangement convenient. The vehicle was comfortable and worked well for my luggage and travel needs.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Kulkarni",
    feedback: "Our family used the sedan cab for a local trip in Pune. The vehicle was comfortable and the private travel arrangement made the journey easy for us.",
    rating: 5
  }
];




  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Pune to Mumbai Airport Cab",
      link: "pune-to-mumbai-airport-cab-service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Pune to Outstation Cabs",
      link: "Pune-to-Outstation-Cabs",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Pune to Mahabaleshwar Cab",
      link: "pune-to-mahabaleshwar-cab-service",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Pune to Lonavala Cab",
      link: "pune-to-lonavala-cab-service",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Pune to Matheran Cabs",
      link: "pune-to-matheran-cab-service",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Pune to 5 Jyotirlinga Darshan Cab",
      link: "pune-to-5-jyotirlinga-cab-service",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Pune to Bhimashankar Cab",
      link: "pune-to-bhimashankar-cab-service",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Pune to Aurangabad Cab Service",
      link: "Pune-to-Aurangabad-Cab-Service",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Pune to Nashik Cab Service",
      link: "Pune-to-Nashik-Cab-Service",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Pune to Kolhapur Cab Service",
      link: "Pune-to-Kolhapur-Cab-Service",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Pune to Alibaug Cab",
      link: "Pune-to-Alibaug-Cab",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "Goa to Pune Cabs",
      link: "Goa-to-Pune-Cabs",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Innova Crysta Cab in Pune",
      link: "Innova-Crysta-Cab-in-Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Ertiga On Rent in Pune",
      link: "Ertiga-On-Rent-in-Pune",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Ashtavinayak Cabs",
      link: "pune-to-ashtavinayak-cab-service",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Goa Cabs",
      link: "Pune-to-Goa-Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Jyotirlinga Darshan Package",
      link: "Pune-to-Jyotirlinga-Darshan-Package",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Akkalkot Cabs",
      link: "Pune-to-Akkalkot-Cabs",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Pandharpur Cab",
      link: "Pune-to-Pandharpur-Cab",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Grishneshwar Jyotirlinga Cab",
      link: "Pune-to-Grishneshwar-Jyotirlinga-Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Mumbai Cabs",
      link: "pune-to-mumbai-cab-service",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Alibag Cab",
      link: "Pune-to-Alibag-Cab",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Innova Crysta On Rent in Pune",
      link: "Innova-Crysta-On-Rent-in-Pune",
    },

  ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Sedan Cab Service",
  "image": "https://garudcabs.com/assets/images/sedan-cab-service.webp",
  "description": "Book Sedan Cab Service in Pune with Garud Cab for comfortable, air-conditioned, and reliable local and outstation travel. Get Sedan taxi booking and cab hire services for airport transfers, one way trips, round trips, corporate travel, and outstation journeys with convenient pickup and drop options.",
  "brand": {
    "@type": "Brand",
    "name": "Garud Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7934"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://garudcabs.com/sedan-cab-service"
  }
};





  return (
    <div>


<Helmet>
  <title>Sedan Cab Service in Pune | Airport & Outstation Taxi | +91 9970007784</title>

  <meta
    name="description"
    content="Book Sedan Cab Service in Pune with Garud Cab for comfortable AC taxi travel. Get Sedan cab booking, hire, airport, outstation, one way, and round trip services with reliable pickup and drop options."
  />

  <meta
    name="keywords"
    content="Sedan cab service in Pune, Sedan Cab Service in Pune, Sedan Taxi Service Pune, Sedan Cab Booking Pune, Sedan Cab Hire Pune, Sedan Taxi Booking Pune, Sedan Outstation Cab Pune, Sedan Airport Cab Pune, Sedan One Way Cab Pune, Sedan Round Trip Cab Pune, AC Sedan Cab Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>





      <section className="page-banner">
        <div className="page-banner-container">
          <h2>
            {cardData.keyword}
          </h2>
        </div>
      </section>








      <section>
        <div className="container-fluid p-0" >
          <div className="row container-fluid px-md-2">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/33.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Garud Cabs Services: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>





              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>



              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-dark">
                  Why Choose <span>Garud Cabs Services</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Garud Cabs Services </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919970007784 " className="pc-call">+91 9970007784 </a>
                    </div>
                    <div className="pc-list">
                      <a href="tel:+919970353709 " className="pc-call">+91 9970353709 </a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919970007784 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919970007784 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@garudcabs.com" className="pc-email">
                      booking@garudcabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Garud Cabs Services</strong><br />
                      Office No.101 Anand Heights
                      Chandan Nagar, Kharadi, Pune,
                      Maharashtra, India-  411014




                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Sedanacabservice;